export function isCampaignOwner(store, campaignId) {
  const state = store.getState()
  return (
    state.campaign &&
    state.campaign[campaignId] &&
    state.campaign[campaignId].is_owner
  )
}
